export default __webpack_public_path__ + "static/media/service_point.f140ad8e.svg";